module.exports = __webpack_public_path__ + "static/media/AVI_0615.52c6caed.jpg";